const INITIAL_STATE = {
    cidades: [],
    cidade: {}
}

export default function Cidade(state = INITIAL_STATE, action) {
    switch(action.type) {
        case 'CIDADES_FETCHED' :
            return { ...state, cidades: action.payload }
        case 'CIDADE_FETCHED' :
            return { ...state, cidade: action.payload }
        default :
            return state
    }
}